import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { leadTimeEnforcementList } from '@/module/Travel/Settings/model/TravelSettingsTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type LeadTimeEnforcementSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function LeadTimeEnforcementSelectControl<T extends FieldValues>(
  props: LeadTimeEnforcementSelectControlProps<T>,
) {
  const { t } = useTranslation();
  const options = useMemo(
    () => leadTimeEnforcementList.map(value => ({ value, label: t(`travel.leadTimeEnforcementEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
